"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _get = _interopRequireDefault(require("lodash/get"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _reverse = _interopRequireDefault(require("lodash/reverse"));

var _lodash = _interopRequireDefault(require("lodash"));

var _ThemeProvider = require("../../ThemeProvider");

var _Pagination = _interopRequireDefault(require("../Pagination"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Table =
/*#__PURE__*/
function (_Component) {
  _inherits(Table, _Component);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          data = _this$props.data,
          paginationPage = _this$props.paginationPage,
          paginationTotal = _this$props.paginationTotal;

      if (paginationPage && paginationPage !== _this.state.paginationPage) {
        _this.setState({
          paginationPage: paginationPage
        });
      } // Update the pagination if not explicitly setting the total


      if (paginationTotal && paginationTotal !== _this.state.paginationTotal) {
        _this.setState({
          paginationTotal: paginationTotal
        });
      } else if (!paginationTotal && data.length !== _this.state.paginationTotal) {
        _this.setState({
          paginationTotal: data.length
        });
      } // If the data length changes go back to the first page
      // This means we are internally paginating the data


      if (!paginationPage && data.length < prevProps.data.length) {
        _this.setState({
          paginationPage: 1
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setSort", function (sortPath, sortDir) {
      if (_this.state.sortPath !== sortPath) sortDir = 'asc';

      if (_this.state.sortPath === sortPath && _this.state.sortDir === 'desc') {
        sortPath = null;
        sortDir = null;
      }

      _this.setState({
        sortPath: sortPath,
        sortDir: sortDir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "sort", function () {
      if (_this.state.sortPath && _this.state.sortDir) {
        if (_this.props.onSort) {
          _this.props.onSort(_this.props.data, _this.state.sortPath, _this.state.sortDir);

          return _this.props.data;
        }

        var data = (0, _sortBy["default"])(_this.props.data, _this.state.sortPath);
        if (_this.state.sortDir === 'desc') return (0, _reverse["default"])(data);
        return data;
      }

      return _this.props.data;
    });

    _defineProperty(_assertThisInitialized(_this), "paginate", function (data) {
      if (!data.length) return data;
      if (_this.props.onPagination) return data; // @todo perf optimization potential

      var pages = _lodash["default"].chunk(data, _this.props.paginationSize);

      return pages[_this.state.paginationPage - 1];
    });

    _defineProperty(_assertThisInitialized(_this), "head", function () {
      return _react["default"].createElement("thead", null, _react["default"].createElement("tr", null, _this.props.columns.map(_this.headCell)));
    });

    _defineProperty(_assertThisInitialized(_this), "body", function () {
      var body = _this.paginate(_this.sort());

      var rows;

      if (body.length) {
        rows = body.map(_this.row);
      } else {
        rows = [_react["default"].createElement("tr", null, _react["default"].createElement("td", null, "No Entries"))];
      }

      return _react["default"].createElement("tbody", null, rows);
    });

    _defineProperty(_assertThisInitialized(_this), "row", function (data) {
      return _react["default"].createElement("tr", {
        key: (0, _uniqueId["default"])('row')
      }, _this.props.columns.map(function (column) {
        return _this.cell(data, column);
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "headCell", function (column) {
      var _classnames;

      return _react["default"].createElement("th", {
        key: (0, _uniqueId["default"])('head'),
        className: (0, _classnames3["default"])((_classnames = {}, _defineProperty(_classnames, _this.props.theme.sortable, column.sort !== false), _defineProperty(_classnames, _this.props.theme.active, _this.state.sortPath === column.path), _classnames), column.className),
        onClick: column.sort !== false ? function () {
          return _this.setSort(column.path, _this.state.sortDir === 'asc' ? 'desc' : 'asc');
        } : undefined
      }, column.heading, _this.state.sortPath === column.path && _react["default"].createElement("i", {
        className: (0, _classnames3["default"])('material-icons', _this.props.theme.sortIcon)
      }, "arrow_drop_".concat(_this.state.sortDir === 'asc' ? 'up' : 'down')));
    });

    _defineProperty(_assertThisInitialized(_this), "cell", function (data, column) {
      return _react["default"].createElement("td", {
        key: (0, _uniqueId["default"])('cell')
      }, column.template ? column.template(data) : (0, _get["default"])(data, column.path));
    });

    _defineProperty(_assertThisInitialized(_this), "handlePagination", function (paginationPage) {
      if (_this.props.onPagination) {
        _this.props.onPagination(paginationPage);
      } else {
        _this.setState({
          paginationPage: paginationPage
        });
      }
    });

    _this.state = {
      sortPath: '',
      sortDir: '',
      paginationPage: props.paginationPage || 1,
      paginationTotal: props.paginationTotal || props.data.length
    };
    return _this;
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          columns = _this$props2.columns,
          theme = _this$props2.theme,
          zebra = _this$props2.zebra,
          className = _this$props2.className,
          hidePagination = _this$props2.hidePagination,
          rest = _objectWithoutProperties(_this$props2, ["data", "columns", "theme", "zebra", "className", "hidePagination"]);

      return _react["default"].createElement("table", {
        className: (0, _classnames3["default"])(theme.table, className, _defineProperty({}, theme.zebra, zebra))
      }, this.head(), this.body(), hidePagination ? null : _react["default"].createElement("tfoot", null, _react["default"].createElement("tr", null, _react["default"].createElement("td", {
        colSpan: columns.length
      }, _react["default"].createElement(_Pagination["default"], {
        settings: {
          total: this.state.paginationTotal,
          pageSize: this.props.paginationSize,
          currentPage: this.state.paginationPage
        },
        nextPage: this.handlePagination
      })))));
    }
  }]);

  return Table;
}(_react.Component);

var _default = (0, _ThemeProvider.applyTheme)('Table', Table);

exports["default"] = _default;